export const BACKEND_URL = 'https://webhook-server-59gy.onrender.com';

// export const BACKEND_URL = 'http://localhost:5000';
